{
  "nav": "Server room",
  "title": "Server room",
  "subtitle": "Network, Wi-Fi base station, server and NAS status reported by the site management station (view only).",
  "loading": "Loading…",
  "not_found": "No server room you can view.",
  "col": {
    "site": "Location",
    "station": "Management station",
    "online": "Connection"
  },
  "online": "Online",
  "offline": "Offline",
  "tab": {
    "overview": "Overview",
    "router": "Router",
    "ap": "Wi-Fi base station",
    "servers": "Servers",
    "nas": "NAS"
  },
  "tool": {
    "site.status": "Overview",
    "net.devices": "Connected devices",
    "net.wan": "Internet",
    "net.wifi": "Wi-Fi",
    "net.traffic": "Traffic",
    "net.dhcp.list": "Reserved IPs",
    "net.forward.list": "Port forwarding",
    "net.logs": "Logs",
    "ap.status": "Status",
    "ap.clients": "Connected clients",
    "ap.wifi": "Wi-Fi settings",
    "srv.health": "Servers",
    "nas.health": "NAS"
  },
  "refresh": "Refresh",
  "running": "Querying…",
  "updated": "Updated {{at}}",
  "wait": " (waiting {{s}} s)",
  "error": "Query failed: {{code}}",
  "run_state": "Query did not finish: {{state}} {{code}}",
  "no_resources": "No devices of this kind are registered on this station."
}
